import React, { useRef, useState, useEffect, useContext } from 'react'
import './styles.scss'

import contractContext from '../../../../../store/contexts/contractContext'
import CONTRACT_ACTIONS from '../../../../../store/actions/contractActions'

import RoundedButtonsRow from '../../../../../components/RoundedButtonsRow'
import Button from '../../../../../components/Button'

import get from 'lodash/get'
import { useCommonStyles } from 'styles/globalStyles'

export default function ContractDuration() {
  const context = useContext(contractContext)
  const commonClasses = useCommonStyles()

  const selecContainerRef = useRef(null)
  const [containerHeight, setContainerHeight] = useState(0)
  const [years, setYears] = useState(get(context, 'proposition.details.duration', 1))

  const handleNext = () => {
    const { propositionDispatch } = context.proposition

    propositionDispatch({
      type: CONTRACT_ACTIONS.SET_DURATION,
      value: years,
    })

    context.handleStepChange('Review')
  }

  useEffect(() => {
    setContainerHeight(get(selecContainerRef, 'current.clientWidth') * 0.8)
  }, [selecContainerRef])

  return (
    <div>
      <p className={commonClasses.contractSubtitle}>
        Selecione a duração do contrato de locação do seu imóvel
      </p>
      <div className='aligner'>
        <div
          ref={selecContainerRef}
          className='duration-select-container'
          style={{ height: containerHeight }}
        >
          <div className='years-amount-container'>
            <div className='years-amout'>
              <span>0{years}</span>
              <span>ano{years > 1 && 's'}</span>
            </div>
          </div>
          <div className='years-select'>
            <RoundedButtonsRow
              type='Years_amount'
              hasDoesntMatter={false}
              min={1}
              max={3}
              selectedValue={years}
              setValue={(type, amount) => setYears(amount)}
            />
          </div>
        </div>
      </div>
      <div className='end-aligner'>
        <div className='button-footer'>
          <Button title='Voltar' onClick={() => context.handleStepChange('PaydaySelect')} />
          <Button title='CONFIRMAR' onClick={handleNext} />
        </div>
      </div>
    </div>
  )
}
